/** scoreRanking.services  */

import { PageRequest } from '@/interface/index.interface';
import { definitions } from '@/types/api';
import axios from '@/axios/fetch';

const scoreRankingServices = () => {
  /** 根据学生code查询已完成实验列表 */
  const listExperimentApi = async (param: PageRequest<{}>): Promise<Required<definitions['Page«ExperimentScoreResponse»']>> => {
    const { data } = await axios.post('./api/experiment/queryScoreByUserId', param);
    return data.data;
  };
  return {
    listExperimentApi,
  };
};

export default scoreRankingServices;
